var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-just-icon md-round",class:{
  'left-icon' : !_vm.noLeft , 
  'md-info' : !_vm.color || _vm.color === 'md-info',
  'md-danger' : _vm.color === 'md-danger',
},on:{"click":[function($event){return _vm.$emit('click')},function($event){$event.stopPropagation();}]}},[_c('md-icon',[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }